import { useTranslation } from 'react-i18next';

import { TaxonomyList } from './components/TaxonomyList';
import { TaxonomySelect } from './components/TaxonomySelect';
import { TaxonomyProvider } from './contexts/TaxonomyContext';

export function Taxonomy() {
  const { t } = useTranslation();
  return (
    <TaxonomyProvider>
      <div className="py-8">
        <section className="mb-10">
          <h1 className="text-[42px] tracking-[8.25px]">
            {t('pages.Taxonomy.title')}
          </h1>
        </section>
        <div className="w-full max-w-[1280px]">
          <TaxonomySelect />
          <TaxonomyList />
        </div>
      </div>
    </TaxonomyProvider>
  );
}
